// extracted by mini-css-extract-plugin
module.exports = {"peopleList":"peopleList_sihwe","noneAvailable":"noneAvailable_b6zcd"};